import {
    useCreateController,
    CreateContextProvider,
    Form,
    SaveButton,
    useNotify,
    useTranslate,
    useRefresh,
    SelectInput,
    required,
    TextInput,
    FormDataConsumer
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton,
    Stack,
    Typography,
    Box
} from '@mui/material';

import { Resources } from '../resource';
import CreateForm from './CreateForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateSystemRpc = ({ onClose }: { onClose: () => void }) => {
    

    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();


    const controller = useCreateController({
        resource: Resources.systemRpc,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.systemRpc.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'RPC_EXISTS':
                        notify(t('module.systemRpc.validate.conflict'), { type: 'error' });
                        break;
                    case 'INTERNAL_SERVER_ERROR':
                        notify(error?.message, { type: 'error' });
                        break;
                    default:
                        notify(t('module.systemRpc.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });

    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.systemRpc.create")}</DialogTitle>
                <DialogContent>
                    <CreateForm />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="rpc" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateSystemRpc;
